<template>
  <div class="a">
    <div class="part5" v-if="this.$isMobile">
      <img class="bg" src="../assets/footer/footer.jpg" alt="" />
      <div class="flex switch">
        <div
          @click="open(index)"
          v-for="(item, index) in list"
          :key="index"
          @mouseover="activeIcon = index"
        >
          <img :src="activeIcon == index ? item.acUrl : item.url" alt="" />
        </div>
      </div>
    </div>
    <div v-else class="part5">
      <img class="bg" src="../assets/index/footerBg.png" alt="" />
      <div class="wrap">
        <div class="logo">
          <img src="../assets/index/footerLogo.png" alt="" />
        </div>
        <div class="list">
          <div class="title">快速通道</div>
          <div>
            <div class="flex">
              <div class="subt" @click="go('customized')">专业定制</div>
              <div class="subt" @click="go('about')">关于阁韵</div>
              <div class="subt" @click="go('goods')">产品介绍</div>
              <div class="subt" @click="go('service')">服务介绍</div>
            </div>
            <div class="flex">
              <div class="subt" style="margin-bottom: 0" @click="go('Dynamic')">
                阁韵动态
              </div>
              <div class="subt" style="margin-bottom: 0" @click="go('anli')">
                阁韵案例
              </div>
              <div class="subt" style="margin-bottom: 0" @click="go('attract')">
                招商加盟
              </div>
              <div class="subt" style="margin-bottom: 0" @click="go('concat')">
                联系我们
              </div>
            </div>
          </div>
        </div>
        <div class="about">
          <div class="title">关于我们</div>
          <div class="sm">
            <div class="smInner">
              <div
                class="smItem"
                @mouseover="showwb = true"
                @mouseleave="showwb = false"
              >
                <img v-if="showwb" class="ewm" :src="`${wxurl}`" alt="" />
                <img
                  class="img"
                  :src="
                    showwb
                      ? require('../assets/footer/wx2.svg')
                      : require('../assets/footer/wx.svg')
                  "
                  alt=""
                />
              </div>
              <div
                class="smItem"
                @mouseover="showNumber = true"
                @mouseleave="showNumber = false"
              >
                <img
                  v-if="showNumber"
                  class="phoneNumber"
                  src="../assets/index/phoneNumber.png"
                  alt=""
                />
                <img
                  class="img"
                  :src="
                    showNumber
                      ? require('../assets/footer/dh2.svg')
                      : require('../assets/footer/dh1.svg')
                  "
                  alt=""
                />
              </div>
              <div
                class="smItem"
                @mouseover="showDy = true"
                @mouseleave="showDy = false"
              >
                <img v-if="showDy" class="dy" :src="`${dyurl}`" alt="" />
                <img
                  class="img"
                  :src="
                    showDy
                      ? require('../assets/footer/dy2.svg')
                      : require('../assets/footer/dy1.svg')
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="about" style="border-right: none">
          <div class="title">联系我们</div>
          <div class="phone">{{ tel }}</div>
          <div class="address">哈尔滨市南岗区前兴隆工业园区</div>
        </div>
      </div>
      <div class="copy">
        © COPYRIGHT {{ address }} 版权所有 黑ICP备17002922号-1
      </div>
    </div>
  </div>
</template>

<script>
import { footer } from "../api/request";
export default {
  name: "Part5",
  props: {
    index: {
      default: 4,
    },
  },
  data() {
    return {
      // 地址
      address: "",
      dyurl: "",
      tel: "",
      wxurl: "",
      showwb: false,
      showNumber: false,
      showDy: false,
      list: [
        {
          url: require("../assets/footer/wb1.png"),
          acUrl: require("../assets/footer/wb2.png"),
        },
        {
          url: require("../assets/footer/dy1.png"),
          acUrl: require("../assets/footer/dy2.png"),
        },
        {
          url: require("../assets/footer/tt1.png"),
          acUrl: require("../assets/footer/tt2.png"),
        },
        {
          url: require("../assets/footer/tm1.png"),
          acUrl: require("../assets/footer/tm2.png"),
        },
      ],
      animate: true,
      sort: 1,
      active: "",
      bg: require("../assets/index/serBg1.png"),
      qlyf: require("../assets/index/qlyf1.png"),
      qgc: require("../assets/index/qgc.png"),
      qth: require("../assets/index/qth.png"),
      activeIcon: "-1",
    };
  },
  mounted() {
    // 请求产品介绍(主图)
    footer().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        var footerobj = res.data.data;
        this.address = footerobj.address;
        this.dyurl = footerobj.dy_image;
        this.wxurl = footerobj.wx_image;
        this.tel = footerobj.tel;
      }
    });
  },
  methods: {
    open(index) {
      // console.log(index);
      this.activeIcon = index;
      switch (index) {
        case 0:
          window.open("https://weibo.com/u/7022968981");
          break;
        case 1:
          window.open(" https://v.douyin.com/8ktFthf/");
          break;
        case 2:
          window.open(
            "https://profile.zjurl.cn/rogue/ugc/profile/?version_code=854&version_name=80504&user_id=101244350170&media_id=1606560557914125&request_source=1&active_tab=dongtai&device_id=65&app_name=news_article&share_token=18903375-5c64-4cbd-aa00-36d8e15a5c7f&tt_from=copy_link&utm_source=copy_link&utm_medium=toutiao_android&utm_campaign=client_share?=推荐《阁韵木窗》的主页  - 今日头条"
          );
          break;
        case 3:
          window.open("https://m.tb.cn/h.fQEFUb4?sm=dc54c9");
          break;
      }
    },
    top() {
      cancelAnimationFrame(this.timer);
      const self = this;
      self.timer = requestAnimationFrame(function fn() {
        const oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          self.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(self.timer);
        }
      });
    },
    go(name) {
      this.$router.push(name);
      this.top();
    },
  },

  watch: {
    index(val) {
      console.log(val);
      this.active = val;
    },
  },
};
</script>

<style scoped lang="less">
.a {
  // overflow: auto !important;
}
.part5 {
  font-family: 微软雅黑, MicrosoftYaHei;
  color: #ffffff;
  min-width: 1920px;

  height: 350px;
  position: relative;
  padding: 1px;

  .bg {
    position: absolute;
    left: 0;
    top: -1px;
    width: 100%;
    height: 100%;
  }
  .wrap {
    margin: 75px 0 0 320px;
    position: relative;
    z-index: 10;
    display: flex;
    align-items: flex-start;
  }
  .logo {
    width: 140px;
    height: 50px;
    img {
      width: 140px;
      height: 50px;
    }
  }
  .about {
    margin-left: 80px;
    height: 125px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    padding-right: 83px;
    border-right: 1px solid #ffffff;
    .sm {
      width: 170px;
      height: 50px;
      display: flex;
      align-items: center;
      position: relative;
      .smInner {
        position: absolute;
        top: 0;
        left: 0;
        width: 170px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .smItem {
          width: 50px;
          height: 50px;
          border-radius: 100px;
          /*background: #004C31;*/
          position: relative;
          .img {
            width: 100%;
            height: 100%;
          }
          .dy {
            z-index: 2100;
            width: 200px;
            height: 200px;
            position: absolute;
            top: -220px;
            left: -60px;
          }
          .phoneNumber {
            width: 185px;
            height: 65px;
            position: absolute;
            top: -80px;
            left: -70px;
          }
          .ewm {
            width: 200px;
            height: 200px;
            position: absolute;
            top: -210px;
            left: -70px;
          }
        }
      }
    }
    .phone {
      font-size: 23px;
      font-weight: 400;
      margin-top: 34px;
      color: #ffffff;
    }
    .address {
      font-size: 14px;
      font-weight: 400;
      margin-top: 14px;
      color: #ffffff;
    }
    .title {
      color: #1f945c;
      font-size: 16px;
    }
  }
  .list {
    min-width: 400px;

    // border: 1px solid blue;
    // margin: 0 80px 0px 0;
    padding-left: 200px;
    padding-right: 80px;
    display: flex;

    flex-wrap: nowrap;
    // align-items: flex-start;
    flex-direction: column;
    border-right: 1px solid #ffffff;
    .flex {
      // border: 1px solid orange;
      // width: 300px;
      display: flex;
      // align-items: center;
      flex-wrap: nowrap;
      min-width: 400px;
      // white-space: nowrap;

      justify-content: space-between;
      .subt {
        margin-right: 10px;
        display: flex;
        // flex-wrap: nowrap;
        white-space: nowrap;
        cursor: pointer;
        font-size: 14px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 24px;
      }
    }
    .title {
      margin-bottom: 36px;
      color: #1f945c;
      font-size: 16px;
      text-align: left;
    }
  }
  .copy {
    position: relative;
    font-size: 15px;
    font-family: 微软雅黑, MicrosoftYaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 21px;
    text-align: center;
    margin-top: 100px;
  }
}
@media screen and (max-width: 450px) {
  .part5 {
    font-family: 微软雅黑, MicrosoftYaHei;
    color: #ffffff;
    width: 100%;
    height: auto;
    .bg {
      position: relative;
      width: 1920px;
      height: auto;
    }
    .switch {
      display: flex;
      align-items: center;
      position: absolute;
      z-index: 2001;
      top: 250px;
      left: 50%;
      margin-left: -400px;
      width: 800px;
      justify-content: space-around;
      div {
        width: 150px;
        height: 150px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .wrap {
      margin: 75px 0 0 75px;
      position: relative;
      z-index: 10;
      display: unset;
    }
    .logo {
      margin: 0 auto;
      width: 140 * 3px;
      height: 50 * 3px;
      img {
        width: 140 * 3px;
        height: 50 * 3px;
      }
    }
    .about {
      margin-left: 75px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      padding-right: 83px;
      border-right: 1px solid #ffffff;
      .sm {
        width: 133 * 3px;
        height: 40 * 3px;
        margin-top: 62px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .phone {
        font-size: 1.75rem;
        font-weight: 400;
        margin-top: 34px;
        color: #ffffff;
      }
      .address {
        font-size: 14 * 2px;
        font-weight: 400;
        margin-top: 34px;
        color: #ffffff;
      }
      .title {
        color: #1f945c;
        font-size: 16 * 4px;
      }
    }

    .list {
      margin-top: 70px;
      padding: 0 80px 0px 0;
      margin-left: 75px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: row;
      border-right: 1px solid #ffffff;
      .flex {
        width: 60%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        .subt {
          width: 250px;
          text-align: right;
          font-size: 14 * 4px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #ffffff;
          margin-bottom: 24px;
        }
      }
      .title {
        text-align: left;
        width: 400px;
        margin-bottom: 36px;
        color: #1f945c;
        font-size: 16 * 4px;
      }
    }
    .copy {
      height: 210px;
      position: relative;
      font-size: 15 * 2px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 210px;
      text-align: center;
      margin-top: 80px;
    }
  }
}
</style>
